import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { LoyaltyConfigService } from "./loyalty.config";
import {
	LoyaltyBalance,
	LoyaltyHistoryFilter,
	LoyaltyHistoryResponse,
	LoyaltyLevelDetail,
	LoyaltyMonthlyHistoryResponse,
} from "./loyalty.model";

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - use fabric LoyaltyService from app-account instead
 */
export class LoyaltyService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: LoyaltyConfigService
	) {}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyBalance)" instead
	 */
	getBalance(): Observable<LoyaltyBalance> {
		return this.httpClient.get<LoyaltyBalance>({
			url: this.config.getBalanceEndpoint(),
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyHistory)" instead
	 */
	getHistory(filter: LoyaltyHistoryFilter = {}): Observable<LoyaltyHistoryResponse> {
		return this.httpClient.get<LoyaltyHistoryResponse>({
			url: this.config.getHistoryEndpoint(),
			searchParams: {
				dateFrom: filter.from,
				dateTo: filter.to,
				pageSize: this.config.historyPageSize(),
				pageIndex: filter.pageIndex || 0,
			},
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyMonthlyHistory)" instead
	 */
	getMonthlyHistory(): Observable<LoyaltyMonthlyHistoryResponse> {
		return this.httpClient.get<LoyaltyMonthlyHistoryResponse>({
			url: this.config.getMonthlyHistoryEndpoint(),
			searchParams: {
				pageSize: 5,
				pageIndex: 0,
			},
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyLevel)" instead
	 */
	getBrandLoyaltyLevels(): Observable<LoyaltyLevelDetail[]> {
		return this.httpClient.get<LoyaltyLevelDetail[]>({
			url: this.config.getBrandLoyaltyLevelsEndpoint(),
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppCommand.GetLoyaltyExchangePoints)" instead
	 */
	exchangePoints(amount: number): Observable<any> {
		return this.httpClient.post({
			url: this.config.getExchangePointsEndpoint(),
			searchParams: {
				amount,
			},
		});
	}
}
